import React from 'react';
import TextInput from '../UI/TextInput';
import EmailInput from '../UI/EmailInput';
import { useForm } from 'react-hook-form';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { ReactComponent as TooltipIcon } from '../../assets/icons/tooltip.svg';

const BUSINESS_INPUT_LIST = [
  {
    label: "Business name",
    name: "name",
    required: true,
    type: "text",
    tooltip: "Type the name of your business"
  },
  {
    label: "Web address",
    name: "url",
    required: false,
    type: "text",
    tooltip: "If you have a website, type your web site address. (for example www.ourcompany.com)"
  },
  {
    label: "Contact",
    name: "contact",
    required: true,
    type: "text",
    tooltip: "Type the name of the contact person at your business"
  },
  {
    label: "Address",
    name: "address1",
    required: true,
    type: "text",
    tooltip: "123 Maple Street"
  },
  {
    label: "Address 2",
    name: "address2",
    required: false,
    type: "text",
    tooltip: "Apartment Number 123 / Suite 123"
  },
  {
    label: "City",
    name: "city",
    required: true,
    type: "text",
    tooltip: "The City in which you live or work."
  },
  {
    label: "State",
    name: "state",
    required: true,
    type: "text",
    tooltip: "MatchForce is intended for businesses located in North Carolina.  If you are not located in NC, please register as an Associate Business."
  },
  {
    label: "County",
    name: "county",
    required: false,
    type: "text",
    tooltip: "NC County in which you live or work"
  },
  {
    label: "ZIP Code",
    name: "zip",
    required: true,
    type: "text",
    tooltip: "Zip code in which you live or work"
  },
  {
    label: "Phone",
    name: "phone",
    required: true,
    type: "tel",
    tooltip: "Please provide your phone number"
  },
  {
    label: "Fax",
    name: "fax",
    required: false,
    type: "tel",
    tooltip: "In the event that you have a fax number, please provide it. This field is not required."
  },
  {
    label: "Alternate Email address",
    name: "email",
    required: false,
    type: "email",
    tooltip: "Please provide a valid email address, such as joe@gmail.com. This will not be used at all times, however can be used in the event you forget your password."
  }
]

const FrameOne = ({ onSubmit }) => {
  const { register, handleSubmit, errors } = useForm();

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {BUSINESS_INPUT_LIST.map(item => {
        const { name } = item;
        if (item.type === 'text') {
          return (
            <fieldset key={item.label}>
              <label htmlFor={item.name}>{item.label} {item.required && <span>*</span>}</label>
              <div className="tooltip-container">
                <TextInput 
                  name={item.name}
                  type={item.type}
                  register={register(item.required && { required: true })}
                />
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip id="button-tooltip">
                      {item.tooltip}
                    </Tooltip>
                  }
                >
                  <TooltipIcon />
                </OverlayTrigger>
              </div>
              {errors[name] && (
                <p className="warnMessage">This field is required</p>
              )}
            </fieldset>
          )
        } else if (item.type === 'email') {
          return (
            <fieldset key={item.label}>
              <label htmlFor={item.name}>{item.label} {item.required && <span>*</span>}</label>
              <div className="tooltip-container">
                <EmailInput 
                  name={item.name}
                  type={item.type}
                  register={register(item.required && { required: true })}
                />
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip id="button-tooltip">
                      {item.tooltip}
                    </Tooltip>
                  }
                >
                  <TooltipIcon />
                </OverlayTrigger>
              </div>
              {errors[name] && (
                <p className="warnMessage">This field is required</p>
              )}
            </fieldset>
          )
        } else if (item.type === "tel") {
          return (
            <fieldset key={item.label}>
              <label htmlFor={item.name}>{item.label} {item.required && <span>*</span>}</label>
              <div className="tooltip-container">
                <input
                  name={item.name}
                  type={item.type}
                  ref={register(item.required && { required: true })}
                  id={item.name}
                />
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip id="button-tooltip">
                      {item.tooltip}
                    </Tooltip>
                  }
                >
                  <TooltipIcon />
                </OverlayTrigger>
              </div>
              {errors[name] && (
                <p className="warnMessage">This field is required</p>
              )}
            </fieldset>
          )
        }
      })}
      <button 
        type="submit"
        className="filledBtn btnSizes"
      >
        Save & Continue
      </button>
    </form>
  )
}

export default FrameOne;